<div class="page-layout carded fullwidth left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bgv2 primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="margin:0px" id="Principal">

        <!-- CONTENT HEADER -->
        <div class="p-24 tamañoHe" fxLayout="row" fxLayoutAlign="start center">
          <button mat-icon-button class="mr-16" (click)="regresar()" *ngIf="!iframe">
            <mat-icon class="textColor" >arrow_back</mat-icon>
          </button>
          <button mat-icon-button class="mr-16" (click)="regresarIframe()" *ngIf="iframe">
            <mat-icon class="textColor">arrow_back</mat-icon>
          </button>
          <h2 class="m-0 textColor">{{'PRINCIPAL.TITULO' | translate}} - {{nombreEmpresa}}</h2>
          <button mat-icon-button class="mr-16" (click)="copyMessage()" *ngIf="iframe && btnCopyUrlIframe" matTooltip="{{'PRINCIPAL.COPY_URL_RES' | translate}}">
            <mat-icon class="iconCopy">file_copy</mat-icon>
          </button>
          <button mat-icon-button class="mr-16 " *ngIf="iframe && btnCopyHelpIframe" (click)="helpVideo()"  matTooltip="{{'WEB_COMPANY_PROFILE.HELP' | translate}}">
            <span class="material-icons-outlined iconCopy">help_center</span>
          </button>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <ng-container *ngIf="!iframe" >
        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span >{{'PRINCIPAL.SUBTITULO' | translate}}</span>
            </div>
            <!-- / CONTENT TOOLBAR -->
            <div class="w100 p-20" fxFlex>

                <mat-sidenav-container class="h100">
                  <mat-sidenav [mode]="'over'" [(opened)]="menuAbierto" class="w25">
                    <menu (cierraMenu)="menuAbierto = !menuAbierto; statusMenu.next({menu:menuAbierto,detalles:null})" (enviaProducto)="productoElegido.next($event)" (cargaPrevio)="cargaPrevio.next($event)" [brokerEmpresa]="brokerEmpresa.asObservable()" class="m0p0"></menu>
                  </mat-sidenav>
                  <mat-sidenav position="end" [(opened)]="detallesAbierto" class="w33">
                    <detalles [productoElegido]="productoElegido.asObservable()" [infoDetalleProducto]="infoDetalleProducto.asObservable()" (cierraMenu)="detallesAbierto = !detallesAbierto; statusMenu.next({menu:null,detalles:detallesAbierto})" (fijaPanel)="detallesAbierto = !detallesAbierto; statusMenu.next({menu:null,detalles:null,fijar:true})" class="m0p0"></detalles>
                  </mat-sidenav>
                  <mat-sidenav-content class="white">
                    <contenido [cargaPrevio]="cargaPrevio.asObservable()" [statusMenu]="statusMenu.asObservable()" [productoElegido]="productoElegido.asObservable()" (abreMenu)="menuAbierto = !menuAbierto" (abreDetalles)="detallesAbierto = !detallesAbierto" (nombreEmpresa)="nombreEmpresa = $event" (brokerEmpresa)="brokerEmpresa.next($event)" (infoDetalleProducto)="infoDetalleProducto.next($event)" (mostrarIframe)="mostrarIframe($event)"></contenido>
                  </mat-sidenav-content>
                </mat-sidenav-container>
            </div>
        </div>
      </ng-container>
        <ng-container *ngIf="iframe" >
        <ng-container *ngIf="tipoIframe=='wpc'" >
          <div class="divIframe"  *ngIf="urlCorrect">
            <!-- <form action="{{urlTableau}}" method="post" id="RecDatos" target="frameTableau" ></form> -->
            <iframe name="frameTableau" allow="fullscreen" [src]="urlSafe"></iframe>
          </div>

          <div class="NO_FORALL" fxLayout="column" fxLayoutAlign="center center" *ngIf="!urlCorrect">
          <h1 class="h1 secondary-text"><p class="texto">{{textWarning}}</p></h1>
          </div>
        </ng-container>

        <ng-container *ngIf="tipoIframe=='resul'" >
          <div class="divIframe">
            <!-- <form action="{{urlTableau}}" method="post" id="RecDatos" target="frameTableau" ></form> -->
            <iframe name="frameTableau" allow="fullscreen" [src]="urlSafe"></iframe>
          </div>
          </ng-container>
        <ng-container *ngIf="tipoIframe=='resulV2'" >
          <div class="divIframe">
            <!-- <form action="{{urlTableau}}" method="post" id="RecDatos" target="frameTableau" ></form> -->
            <iframe name="frameTableau" allow="fullscreen" [src]="urlSafe"></iframe>
          </div>
          </ng-container>

        </ng-container>



        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
